import React,{useEffect,useState,} from 'react';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

import BlogItem from '../components/Blog/BlogItem';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import {allStates} from '../components/Helper';
import { BrowserRouter as Router,Routes, Route, Link,useParams,useSearchParams } from 'react-router-dom';
import '../App.css';



const Blog=()=>{

const [searchParams, setSearchParams] = useSearchParams();
let { state } = useParams();

const [data, setData] = useState(null);
const [foundState, setFoundState] = useState([]);

const responsive = {
    // breakpoint from 0 up
    0 : {
      items:1
    },
    // breakpoint from 480 up
    560 : {
      items:2
    },
    // breakpoint from 768 up
    768 : {
        items:3
    }
  };

const dataFetch = async () => {

  var thisPage=1;
  if(searchParams.get("p")!=null)
  thisPage=searchParams.get("p");
  if(typeof state === 'undefined'){
    state='';
  }
  fetch('https://api.hudhousingnetwork.com/1/blog?p='+thisPage)
        .then(response => response.json())
        .then((data) =>{
          console.log(data)
          if(data.success==1){
            setData({rowsCount:data.rowsCount,rows:data.rows});
          }
          
          }
        );
};

const BlogPagination=()=>{

  var thisPage=1;
  if(searchParams.get("p")!=null)
  thisPage=searchParams.get("p");


  const ShowLIs=()=>{
    var totalPages=Math.ceil(data.rowsCount/6);

    let lis=[];
    for(let i=1; i<=totalPages; i++){
      var isActive="";
      if(i==thisPage)isActive="active"
      lis.push(<li className={isActive} ><a href={"/blog/?p="+i}>{i}</a></li>);
    }    
    return lis;
  }
  return (
    <ul className="pagination">
      <ShowLIs />
    </ul>
    );
}


useEffect(()=>{
 console.log('Loaded!');  
 dataFetch();

},[])

const setClick=(val)=>{
  var url='/public-housing-waiting-lists/';
  url=url+val;
  window.location.href=url;
  //console.log("clicked "+val.toLowerCase())
}

/*allStates.map((postData) => {
  if(postData['state_code']=='AL'){
    console.log(postData['state'])
  }
})*/

  return (

<>
<Header />



<div className="blog_wrap">
  <h1 className="blogpage-heading">HUD Housing Guides</h1>

  <div className="row">
    
    {data!=null && (
      
          data.rows.map((item,index) => (
            <BlogItem key={index} item={item} />
          ))

      )
    }
  </div>

  <div style={{textAlign:'center',marginBottom:'15px'}}>
  {data!=null && (
    <BlogPagination />
    )
  }
  </div>
  <div style={{clear:'both'}}></div>

</div>



<footer>
    <div className="container">
        <div className="row">
            <div className="footer-left">© 2023 Copyright HUD Housing Network</div>
            <div className="footer-right">
                <div className="f-nav">
                    <ul>
                        <li><a href="https://hudhousingnetwork.com/privacy">Privacy Policy</a></li>
                        <li>|</li>
                        <li><a href="https://hudhousingnetwork.com/terms">Terms &amp; Conditions </a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</footer>












{/*}
  <div className="content_wrapper">
    <div className="main-content">
      <h2 className="top-heading">Public Housing Waiting Lists {foundState!="" ? 'for '+foundState : ''}</h2>
      
      <select className="statesDD" onChange={(e)=>setClick(e.target.value)} >
      {
          allStates.map((postData,index) => {            
            var selected = postData['state_code'].toLowerCase()==state ? 'selected' : '';
            return (<option key={index} selected={selected} value={postData['state_code'].toLowerCase()}>{postData['state']}</option>)
          
        })
      }        
      </select><br />
      
      {data!=null && (
      
          data.map((item,index) => (
            <ListItem key={index} item={item} />
          ))

      )
    }

    {data!=null && data.length==0 && (
    <span className="sorry">Sorry we are unable to find any matching records!</span>)
    }          
    </div>
  <Sidebar />
  </div>
  <div className="content_wrapper">
    <div className="side-box">
      <img src="/img/apt1.png" />
      <div className="side-box-content">
        <h3>Spring View Apartments</h3>
        <p>Read our getting started guide</p>
        <div className="side-box-flex">
          <h4>Section 8 Apartment</h4>
          <a className="applyLink" href="/">Apply</a>  
        </div>  
      </div>
    </div>
    <div className="side-box">
      <img src="/img/apt2.png" alt="" />
      <div className="side-box-content">
        <h3>Spring View Apartments</h3>
        <p>Read our getting started guide</p>
        <div className="side-box-flex">
          <h4>Section 8 Apartment</h4>
          <a className="applyLink" href="/">Apply</a>  
        </div>  
      </div>
    </div>
    <div className="side-box">
      <img src="/img/apt2.png" />
      <div className="side-box-content">
        <h3>Spring View Apartments</h3>
        <p>Read our getting started guide</p>
        <div className="side-box-flex">
          <h4>Section 8 Apartment</h4>
          <a className="applyLink" href="/">Apply</a>  
        </div>  
      </div>
    </div>
  </div>
  <div className="content_wrapper">
    <div className="bottom-box">
      <div className="bottom-box-flex">
        <div className="bottom-box-image"><img src="/img/Housing-authority.png" /></div>
        <div className="bottom-box-content">
          <h2>Housing-authority</h2>
          <p>1243 West Sycamore Lafayette GA, 29010</p>
        </div>
      </div>
      <div className="bottom-box-flex2">
        <a href="" className="contact-us-link">Contact Us</a>
        <div className="bottom-box-icon">
          <img src="/img/Group238491.png" />
          <img src="/img/Group238493.png" />
        </div>
      </div>
    </div>  
  </div>

{*/}






</>
  );
}

export default Blog;
